import { render, staticRenderFns } from "./ProformaAgen.vue?vue&type=template&id=cda4dc24&scoped=true"
import script from "./ProformaAgen.vue?vue&type=script&lang=js"
export * from "./ProformaAgen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda4dc24",
  null
  
)

export default component.exports